<template>
  <div :style="`width:${dispW}px; height:${dispH}px;position:relative;left:0px;top:0px;`">
    <el-container>
      <el-aside :width="`${ColorBarWidth}px`">
        <ColorBar
          :dispW="ColorBarWidth"
          :dispH="dispH - 26"
          :indexInForm="0"
          parentForm="compare2records"
        />
      </el-aside>
      <el-main :style="`padding:0px;height:${dispH}px;`">
        <div style="display:flex;border">
          <div class="params">
            <el-select v-model="recordID1" @change="changeRecord1" placeholder="">
              <el-option
                v-for="(item, index) in records1"
                :key="index"
                :label="`${item.label} ${
                  item._id === record._id && item.eyetype === eyeType ? '*' : ''
                }`"
                :value="item.newId"
              ></el-option>
            </el-select>
            <Map
              :dispW="mapWidth"
              :indexInForm="0"
              parentForm="compare2records"
              :dispH="dispH / 2 - 50"
              :index="0"
              :mapValues="mapValues1"
              :casePath="casePath1"
              :mapIndexUI="mapIndexUI1"
            />
          </div>
          <div class="params">
            <el-select v-model="recordID2" @change="changeRecord2" placeholder="">
              <el-option
                v-for="(item, index) in records2"
                :key="index"
                :label="`${item.label}${
                  item._id === record._id && item.eyetype === eyeType ? '*' : ''
                }`"
                :value="item.newId"
              ></el-option>
            </el-select>
            <Map
              :dispW="mapWidth"
              :indexInForm="1"
              parentForm="compare2records"
              :dispH="dispH / 2 - 50"
              :index="1"
              :mapValues="mapValues2"
              :casePath="casePath2"
              :mapIndexUI="mapIndexUI12"
            />
          </div>
          <div class="params">
            <MapForm
              :isColorBarVisible="false"
              :indexInForm="2"
              parentForm="compare2records"
              :isDiff="true"
              :dispW="mapWidth"
              :dispH="dispH / 2"
              :index="2"
              :record="record"
              :mapValues="mapValuesDiff"
              @changeMapType="changeMapType"
            />
          </div>
        </div>
        <el-footer :height="`${dispH / 2}px`" style="border: none">
          <div style="display: flex; height: 100%">
            <div class="params">
              <CorneaParam
                :mapValues="mapValues1"
                :indexInForm="0"
                :dispW="mapWidth"
                :dispH="dispH / 2"
              />
            </div>
            <div class="params">
              <CorneaParam
                :mapValues="mapValues2"
                :indexInForm="1"
                :dispW="mapWidth"
                :dispH="dispH / 2"
              />
            </div>
            <div class="params" style="border-right: none">
              <CorneaParam
                :mapValues="mapValuesDiff"
                :indexInForm="2"
                :isDiff="true"
                :dispW="mapWidth"
              />
            </div>
          </div>
        </el-footer>
      </el-main>
      <el-aside :width="`${ColorBarWidth}px`">
        <ColorBar
          :dispW="ColorBarWidth"
          :dispH="dispH - 26"
          parentForm="compare2records"
          :indexInForm="2"
          :isDiff="true"
        />
      </el-aside>
    </el-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Map from "./Map.vue";
import MapForm from "./MapForm.vue";
import ColorBar from "./ColorBar";
import CorneaParam from "./CorneaParam.vue";
import {
  NORMALMAPSTYLES,
  MAPSTYLES,
  isFileExists,
  isDefined,
  forgeDeepCopy,
  FILES,
  stopWaiting,
  hasKey
} from "../shared/index";
import DataParams from "../dataGetters/params";
import CaseHandle from "../js/CaseHandle";
import fileSys from "../../fileoprators/fileSystem";
import { PAGES } from "../../shared/consts";
import { getRecordsAll } from "../../services/record";
import { calcElevDiff } from "../js/calc4mmElevDiff";
import EVENTS from "../../bus";

let records;
let record1 = null;
let record2 = null;
let dataparams = new DataParams();
const PARAM = forgeDeepCopy(dataparams.params);
export default {
  name: "Compare2Records",
  data() {
    return {
      ColorBarWidth: 90,
      mapIndexUI1: 1,
      mapIndexUI12: 1,
      options: NORMALMAPSTYLES,
      mapStyles: MAPSTYLES,
      recordID1: "",
      recordID2: "",
      casePath1: null,
      casePath2: null,
      mapValues1: {},
      mapValues2: {},
      mapValuesDiff: {},
      loaded: false
    };
  },
  created() {
    this.initParams();
  },
  mounted() {
    this.initRecords("mounted");
  },
  methods: {
    initRecords(from) {
      this.initVariable();

      getRecordsAll(
        isDefined(this.patient) ? this.patient._id : "",
        { checktype: PAGES.topography },
        (response) => {
          if (isDefined(response.records)) {
            this.procRecordAfterEnter(response.records);
          } else {
            this.$message({
              showClose: true,
              message: "failed",
              type: "error",
              duration: 5000
            });
          }
          this.$emit("hide-waiting");
        }
      );
    },
    initParams(index) {
      switch (index) {
        case 1:
          this.mapValues1 = forgeDeepCopy(PARAM);
          break;
        case 2:
          this.mapValues2 = forgeDeepCopy(PARAM);
          break;
        default:
          this.mapValues1 = forgeDeepCopy(PARAM);
          this.mapValues2 = forgeDeepCopy(PARAM);
          break;
      }

      this.mapValuesDiff = forgeDeepCopy(PARAM);
      if (this.mapValues) {
        this.mapValues1 = forgeDeepCopy(this.mapValues);
      }
    },
    procRecordAfterEnter(_records) {
      let recordsWithEye = [];
      _records.forEach((item) => {
        let osod = item.eyetype;
        let content = item.content;
        if (!isDefined(content)) return false;
        osod.forEach((eye) => {
          if (
            hasKey(content, `data${eye}.topography.diagnosed`) &&
            content[`data${eye}`].topography.diagnosed
          ) {
            recordsWithEye.push({
              newId: item._id + eye,
              _id: item._id,
              patientid: item.patientid,
              eyetype: eye,
              recorddate: item.recorddate,
              label: `${item.recorddate} ${eye}`
            });
          }
        });
      });
      records = recordsWithEye.concat();
      this.records1 = records.concat();
      this.records2 = [];
      this.recordID1 = "";
      this.recordID2 = "";
      if (
        this.record &&
        this.record.contrasts &&
        isDefined(this.record.contrasts[0]) &&
        isDefined(this.record.contrasts[1])
      ) {
        this.mapIndexUI1 = this.mapIndexUI12 = this.record.contrasts[2];
        let recordNewIds = records.map((v) => v.newId);
        this.record1 = record1 =
          this.record.contrasts[0] && recordNewIds.includes(this.record.contrasts[0].newId)
            ? this.record.contrasts[0]
            : records.length
              ? records[0]
              : null;
        if (isDefined(record1)) {
          this.records2 = records.filter((v) => v.newId !== record1.newId);
        }
        this.record2 = record2 =
          this.record.contrasts[1] && recordNewIds.includes(this.record.contrasts[1].newId)
            ? this.record.contrasts[1]
            : this.records2.length
              ? this.records2[0]
              : null;
        if (isDefined(record2)) {
          this.records1 = records.filter((v) => v.newId !== record2.newId);
        }
        if (record1 && this.records1.map((v) => v.newId).includes(record1.newId)) {
          this.recordID1 = record1.newId;
        } else {
          this.recordID1 = this.records1.length ? this.records1[0].newId : "";
        }
        if (record2 && this.records2.map((v) => v.newId).includes(record2.newId)) {
          this.recordID2 = record2.newId;
        } else {
          this.recordID2 = this.records2.length ? this.records2[0].newId : "";
        }
        // this.changeRecord1(this.recordID1)
        // this.changeRecord2(this.recordID2)
      } else {
        if (isDefined(record1) && record1.patientid === this.patientid) {
          this.record1 = record1;
        } else if (isDefined(this.record)) {
          record1 = this.record1 = {
            newId: this.record._id + this.eyeType,
            _id: this.record._id,
            eyetype: this.eyeType,
            recorddate: this.record.recorddate
          };
        }
        if (isDefined(record1)) {
          this.records2 = records.filter((item) => {
            return item.newId !== record1.newId;
          });
        }
        if (isDefined(record2)) {
          this.record2 = record2;
        } else if (isDefined(record1)) {
          record2 = this.record2 = this.records2.filter((item) => {
            return item.eyetype === record1.eyetype;
          })[0];
          if (!isDefined(this.record2)) {
            record2 = this.record2 = this.records2[0];
          }
        } else {
          record2 = this.record2 = this.records2[0];
        }
        if (isDefined(record2)) {
          this.records1 = records.filter((item) => {
            return item.newId !== record2.newId;
          });
        }
        this.recordID1 = isDefined(this.record1) ? this.record1.newId : "";
        this.recordID2 = isDefined(this.record2) ? this.record2.newId : "";
      }
      CaseHandle.initCaseById(this.record1._id, this.record1.eyetype, true, false, (casePath) => {
        this.getAllMapValues(1);
        this.casePath1 = casePath;
        this.record.contrasts = [record1, record2, this.mapIndexUI1];
        this.$bus.$emit(EVENTS.updateData, this.record, {}, {}, () => {});
        if (isDefined(this.record2) && isDefined(this.record2._id)) {
          CaseHandle.initCaseById(
            this.record2._id,
            this.record2.eyetype,
            false,
            true,
            (casePath2) => {
              this.getAllMapValues(2);
              this.casePath2 = casePath2;
              this.getAllMapValues(-1);
              this.record.contrasts = [record1, record2, this.mapIndexUI1];
              this.$bus.$emit(EVENTS.updateData, this.record, {}, {}, () => {});
              stopWaiting(this);
              this.loaded = true;
            }
          );
        } else {
          this.getAllMapValues(2);
          stopWaiting(this);
        }
      });
    },
    getAllMapValues(index) {
      this.initParams(index);
      if ((index === 1 && isDefined(this.record1)) || index === -1) {
        this.mapValues1 = this.getParams(this.record1._id, this.record1.eyetype);
      }
      if ((index === 2 && isDefined(this.record2)) || index === -1) {
        this.mapValues2 = this.getParams(this.record2._id, this.record2.eyetype);
      }
      if (isDefined(this.mapValues1) && isDefined(this.mapValues2)) {
        this.mapValuesDiff = this.calcDiff(this.mapValues1, this.mapValues2);
      }
    },
    changeRecord1(val) {
      if (!this.loaded) return;

      this.records1.forEach((item) => {
        if (item.newId === val) {
          record1 = this.record1 = item;
        }
      });
      if (isDefined(records)) {
        this.records2 = records.filter((item) => {
          return item.newId !== record1.newId;
        });
        if (!this.records2.map((v) => v.newId).includes(this.recordID2)) {
          this.recordID2 = this.records2.length ? this.records2[0].newId : "";
        }
        // record2 = this.record2 = this.records2.filter(item => {
        //   return item.eyetype === this.record1.eyetype
        // })[0]
        // if (!isDefined(this.record2)) {
        //   record2 = this.record2 = this.records2[0]
        // }
        // if (this.record2) this.recordID2 = this.record2.newId
      }
      CaseHandle.initCaseById(this.record1._id, this.record1.eyetype, true, false, (casePath) => {
        this.getAllMapValues(1);
        this.casePath1 = casePath;
      });
      this.record.contrasts = [record1, record2, this.mapIndexUI1];
      this.$bus.$emit(EVENTS.updateData, this.record, {}, {}, () => {});
    },
    changeRecord2(val) {
      if (!this.loaded) return;

      this.records2.forEach((item) => {
        if (item.newId === val) {
          record2 = this.record2 = item;
        }
      });
      if (isDefined(records)) {
        this.records1 = records.filter((item) => {
          return item.newId !== record2.newId;
        });
        if (!this.records1.map((v) => v.newId).includes(this.recordID1)) {
          this.recordID1 = this.records1.length ? this.records1[0].newId : "";
        }
        // record1 = this.record1 = this.records1.filter(item => {
        //   return item.eyetype === this.record1.eyetype
        // })[0]
        // if (!isDefined(this.record1)) {
        //   record1 = this.record1 = this.records1[0]
        // }
        // if (this.record1) this.recordID1 = this.record1.newId
      }
      CaseHandle.initCaseById(this.record2._id, this.record2.eyetype, false, true, (casePath) => {
        this.getAllMapValues(2);
        this.casePath2 = casePath;
      });
      this.record.contrasts = [record1, record2, this.mapIndexUI1];
      this.$bus.$emit(EVENTS.updateData, this.record, {}, {}, () => {});
      // this.casePath2 = this.getCasePath(this.recordID2)
      // this.getAllMapValues(2)
    },
    getParams(recordid, eyetype) {
      let _path = fileSys.getCasePath(`${recordid}_${eyetype}/${FILES.acdotana}`);

      // let _records = records.filter(item => {
      //   return recordid === item._id
      // })
      let settings = this.dataShowSettings;
      let dataparams = new DataParams(fileSys.getCasePath(`${recordid}_${eyetype}`));
      if (isFileExists(_path)) {
        dataparams.getBaseParams();
        dataparams.getMajMedian(settings.medianMode);
        dataparams.params.EccPEQ.value = dataparams.getOneMajMedian(settings.mm);
        let objDiff = calcElevDiff(
          fileSys.getCasePath(`${recordid}_${eyetype}`),
          dataparams.params.AxisFlat.value,
          dataparams.params.AxisSteep.value
        );
        dataparams.params.elevDiff4mm.value = objDiff.val;
        dataparams.params.elevDiff4mm.analog = objDiff.analog;
      }
      // let eyetype = _records.length > 0 ? _records[0].eyetype : ''

      return this.mergeParams(dataparams.params, eyetype);
    },
    calcDiff(mapv1, mapv2) {
      let dataparams = new DataParams();
      dataparams.getBaseParamsDiff(mapv1.params, mapv2.params);
      return {
        params: dataparams.paramsDiff,
        eyetype: ""
      };
    },
    initVariable() {
      records = undefined;
      record1 = null;
      record2 = null;
      this.records1 = [];
      this.records2 = [];
      this.record1 = null;
      this.record2 = null;
      this.recordID1 = "";
      this.recordID2 = "";
      this.casePath1 = null;
      this.casePath2 = null;
      this.mapValues1 = {};
      this.mapValues2 = {};
      this.mapValuesDiff = {};
    },
    mergeParams(params, eyetype) {
      let mapValues = {
        params: params
      };
      mapValues.eyetype = eyetype;
      return mapValues;
    },
    changeMapType(mapIndexUI) {
      this.mapIndexUI1 = this.mapIndexUI12 = mapIndexUI;
      if (
        this.record &&
        this.record.contrasts &&
        isDefined(this.record.contrasts[0]) &&
        isDefined(this.record.contrasts[1])
      ) {
        this.record.contrasts[2] = this.mapIndexUI1;
        this.$bus.$emit(EVENTS.updateData, this.record, {}, {}, () => {});
      }
    }
  },
  watch: {
    record1(newval) {
      record1 = newval;
    },
    record2(newval) {
      record2 = newval;
    },
    eyeType() {
      if (!this.loaded) return;
      this.initVariable();
      this.initParams();
      this.initRecords("eyetype change");
    }
  },
  computed: {
    ...mapGetters(["dataShowSettings"]),
    mapWidth() {
      return (this.dispW - this.ColorBarWidth * 2) / 3 - 2;
    }
  },
  components: {
    Map,
    CorneaParam,
    ColorBar,
    MapForm
  },
  props: {
    dispW: {
      type: Number,
      default: window.screen.width - 30
    },
    dispH: {
      type: Number,
      default: window.screen.height - 80 - 10
    },
    rightsider: {
      type: Object,
      default: () => {
        return {
          isMapBoolen: false,
          isScaleBoolen: true,
          isImageBoolen: false,
          visible: false,
          isDiff: false
        };
      }
    },
    isSelectVisibleBoolen: {
      type: Boolean,
      default: true
    },
    patient: {
      type: Object
    },
    record: {
      type: Object
    },
    value: Boolean,
    eyeType: {
      type: String,
      required: true
    }
  }
};
</script>
<style scoped>
option {
  text-align: center;
}
.el-aside {
  border: none;
}
.el-footer {
  border: 1px solid gray;
  padding: 0px;
}
.params {
  border: 1px solid gray;
  height: 100%;
}
.el-select {
  width: 100%;
}
.el-select /deep/ input {
  font-size: 30px;
  background-color: #44444c;
  color: #fff;
  border-radius: 0px;
}
.el-select /deep/ .el-input__inner {
  font-size: 30px;
  height: 50px;
  background-color: #44444c;
  color: #fff;
  border-radius: 0px;
}
li.el-select-dropdown__item {
  font-size: 40px;
  height: 50px;
  background-color: #44444c;
  color: #fff;
}
.el-select-dropdown__item /deep/ span {
  font-size: 25px;
  height: 50px;
  background-color: #44444c;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/Compare2Records.vue